import React, { useEffect, useState } from 'react';
import { Alert, Dialog, Input } from 'tdesign-react';
import Form from '@/components/Form';
import Text from '@/components/Text';

const { FormItem } = Form;
export default function ConfigModal({
  visible,
  detail,
  onClose,
  brokerHost,
  clusterName,
  updateBrokerService,
}) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        configName: detail.configItem,
        configDesc: detail.configExplanation,
        configValueOld: detail.configValue,
      });
    } else {
      form.resetFields();
    }
  }, [visible, form, detail]);

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      const params = { ...values, brokerHost, clusterName };

      delete params.configDesc;
      delete params.configValueOld;

      await updateBrokerService(params);
      onClose(true);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      header='编辑配置'
      onClose={() => onClose()}
      onConfirm={() => form.submit()}
      confirmBtn={{ loading: submitting, content: '确定' }}
      visible={visible}
      width={650}
    >
      <Alert message='当前配置将应用到全部Broker' theme='info' />
      <Form
        form={form}
        labelWidth={140}
        onFinish={handleSubmit}
        initialValues={{ applyAll: false }}
        style={{ marginTop: 20, width: '90%' }}
      >
        <FormItem label='配置名' name='configName'>
          <Text />
        </FormItem>

        <FormItem label='配置描述' name='configDesc'>
          <Text />
        </FormItem>

        <FormItem label='当前配置' name='configValueOld'>
          <Text />
        </FormItem>

        <FormItem
          label='新配置值'
          name='configValue'
          rules={[{ required: true, message: '配置值必填' }]}
        >
          <Input placeholder='请输入' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
